export const connectionUrl = [
  {
    1: "https://dev-yarnbank.shimaseiki.com",
    2: "https://dev-yarnbank-cn.shimaseiki.com",
    3: "https://dev-yarnbank-org.shimaseiki.com",
    4: "https://dev-admin-yarnbank.shimaseiki.com",
  },
  {
    1: "https://staging-yarnbank.shimaseiki.com",
    2: "https://staging-yarnbank-cn.shimaseiki.com",
    3: "https://staging-yarnbank-org.shimaseiki.com",
    4: "https://staging-admin-yarnbank.shimaseiki.com",
  },
  {
    1: "https://yarnbank.shimaseiki.com",
    2: "https://yarnbank-cn.shimaseiki.com",
    3: "https://yarnbank-org.shimaseiki.com",
    4: "https://admin-yarnbank.shimaseiki.com",
  },
];

export const VIDEO_YOUTUBE_ID = "yUc2ZvnLwl8";

export const URL_VIDEO_YOUTUBE_CHINA = "https://acf001.shimaseiki.com/Delivery/video-player_standard_v1.html?mp=/lms/tdc/webinar/Masteringyarnbank_YourUltimateGuide_general&st=en&st=zh";

export const TOKEN_ERROR_STATUS_CODE = 499;
export const IE_ERROR_STATUS_CODE = 498;

export const USER_TYPE = {
  DEMO: 15040,
  GUEST: 15030,
  USER: 15020,
  SUPPLIER: 15010,
  ADMIN: 15000,
};

export const USER_TYPE_NAV_MAPPER = {
  [USER_TYPE.ADMIN]: { name: "admins" },
  [USER_TYPE.SUPPLIER]: { name: "myyarns", query: { page: 1 } },
  [USER_TYPE.DEMO]: { name: "pr-supplier" },
  [USER_TYPE.USER]: { name: "search" },
  [USER_TYPE.GUEST]: { name: "pr-supplier" },
};

export const IMAGE_FILTER = {
  THUMBNAIL: "THUMBNAIL",
  SWATCH: "SWATCH",
  REFER: "REFER",
};

export const ADD_CARD = {
  BAN: "BAN",
  ACTIVE: "ACTIVE",
};

export const YARN_STATUS = {
  PUBLIC: 21000,
  PRIVATE_UNDER_MAINTENANCE: 21001,
  PRIVATE_DISCONTINUED: 21002,
  PRIVATE_DELETED: 21003,
  UNKNOWN: 21009,
};

export const YARN_CARD_TYPE = {
  YARN_CARD_ADMIN: "ADMIN",
  YARN_CARD_SUPPLIER: "SUPPLIER",
};

export const FORM_CHECKBOX_LIST = [
  "selectedSeason",
  "selectedCharacteristics",
  "selectedFunctions",
  "selectedMaterial",
  "selectedDetailOptionMaterial",
  "selectedOptionMaterial",
  "selectedCertifications",
  "selectedOptionWool",
  "selectedSubSilk",
  "selectedSubCotton",
  "selectedSubPolyester",
  "materialLog",
  "status",
  "selectedRecommend",
  "selectedValidEco",
];

// userRole , authorityLevel
export const USER_POSITION = {
  H_MANAGER: 16000,
  E_MANGER: 16001,
  MANAGER: 16002,
  CUSTOMER_MANAGER: 16010,
  STAFF: 16020,
  GUEST: 16030,
  DEMO: 16040,
};

export const MATERIAL_OPTIONS = {
  PBT: 105109,
  BTT: 105110,
  OTHER_POLYESTER: 105111,
  EXTRA_COTTON: 105107,
  WOOL: 105001,
  OTHER_COTTON: 105108,
  YAK: 105016,
  SILK: 105005,
  POLYESTER: 105007,
  COTTON: 105003,
  OTHER_WOOL: 105102,
  MERINO_WOOL: 105101,
};

export const MATERIAL_SEQ = {
  ANIMAL: 8,
  PLANT: 13,
  OTHER: 23,
};

export const INSTAGRAM = {
  URL: "https://www.instagram.com/yarnbank/",
};

export const YARN_MAKER_BY_LANGUAGE_TYPE = {
  en: "https://www.shimaseiki.com/yarnbank/special/index.html",
  zh: "https://www.shimaseiki.com.cn/yarnbank/special/index.html",
  ja: "https://www.shimaseiki.co.jp/yarnbank/special/index.html",
};

export const YARN_MAKER_IMAGE_PC = {
  en: "https://acf001.shimaseiki.com/Delivery/yarnbank/yarnsuppliers_pce.jpg",
  zh: "https://acf001.shimaseiki.com/Delivery/yarnbank/yarnsuppliers_pcc.jpg",
  ja: "https://acf001.shimaseiki.com/Delivery/yarnbank/yarnsuppliers_pcj.jpg",
};

export const YARN_MAKER_IMAGE_TABLET = {
  en: "https://acf001.shimaseiki.com/Delivery/yarnbank/yarnsuppliers_tbe.jpg",
  zh: "https://acf001.shimaseiki.com/Delivery/yarnbank/yarnsuppliers_tbc.jpg",
  ja: "https://acf001.shimaseiki.com/Delivery/yarnbank/yarnsuppliers_tbj.jpg",
};

export const SCREEN_SIZE = {
  XS: 768,
  LG: 1200,
};

export const CERTIFICATION = {
  BLUE_SIGN: 103001,
  EU: 103002,
  FSC: 103003,
  COTS: 103004,
  OEKO_TEX_101: 103005,
  WOOLMARK: 103099,
  PURE_NEW_WOOL: 103006,
  WOOL_RICH_BLEND: 103007,
  WOOL_BLEND_PERFORMANCE: 103008,
  ATS: 103009,
  ETHIC: 103010,
};

export const IMAGE_URL_TYPE = {
  COLOR: "COLOR",
  YARN_BOOK: "YARN_BOOK",
  LOGO: "LOGO",
  TINY: "TINY",
  SWATCH: "SWATCH",
  REFER: "REFER",
  REFER_SMALL: "REFER_SMALL",
  HANDLING_MARK: "HANDLING_MARK",
  ECO: "ECO",
  COMPANY_PROFILE: "COMPANY_PROFILE",
};

export const HIDDEN_GAUGES = [106001, 106021];

export const colorMapper = [
  {
    codeId: 102001,
    color: "#E50042",
  },
  {
    codeId: 102002,
    color: "#ff99cc",
  },
  {
    codeId: 102003,
    color: "#ec5f13",
  },
  {
    codeId: 102004,
    color: "#ffde00",
  },
  {
    codeId: 102005,
    color: "#009900",
  },
  {
    codeId: 102006,
    color: "#0080ff",
  },
  {
    codeId: 102007,
    color: "#142d6c",
  },
  {
    codeId: 102008,
    color: "#5900b2",
  },
  {
    codeId: 102009,
    color: "#000000",
  },
  {
    codeId: 102010,
    color: "#595959",
  },
  {
    codeId: 102011,
    color: "#ffffff",
  },
  {
    codeId: 102012,
    color: "#803326",
  },
  {
    codeId: 102013,
    color: "#e6cfa1",
  },
  {
    codeId: 102014,
    color:
      "linear-gradient(224deg, #848484, #f2e5f2 50%, #949494 69%, #848484)",
    notRgb: true,
  },
  {
    codeId: 102015,
    color:
      "linear-gradient(224deg, #b48343, #ffedab 49%, #eabf91 64%, #8a612c)",
    notRgb: true,
  },
];

export const YARN_PREVIEW_MODE = {
  PREVIEW: "PREVIEW", // depends on yarnForm
  VIEW: "VIEW",
  ADMIN_VIEW: "ADMIN_VIEW",
};

export const YARN_INFO_TYPES = ["WHOLE", "PART"];

export const YARN_INFO_TYPE = {
  WHOLE: "WHOLE",
  PART: "PART",
};

// common
export const CREATE = "create";
export const UPDATE = "update";
export const LOGIN = "login";
export const LOGOUT = "logout";

// index store
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_SEARCH_CONDITION = "SET_SEARCH_CONDITION";
export const SET_SEARCH_LIST = "SET_SEARCH_LIST";
export const SET_SELECT_YARN = "SET_SELECT_YARN";
export const SET_DYP_BODY_REF = "SET_DYP_BODY_REF";
export const SET_DYP_BODY_TO_TOP = "SET_DYP_BODY_TO_TOP";

// company store
export const COMPANY__CREATE = "company/create";
export const COMPANY__UPDATE = "company/update";

// yarn store
export const YARN__UPDATE = "yarn/update";

// user store
export const USER_LOGIN = "user/login";
export const USER_LOGOUT = "user/logout";

// search store
// mutations
export const SET_MATERIALS = "SET_MATERIALS";
export const SET_PRICE_TYPES = "SET_PRICE_TYPES";
export const SET_YARN_TYPES = "SET_YARN_TYPES";
// actions
export const SEARCH__SET_MATERIALS = "search/setMaterials";
export const SEARCH__SET_PRICETYPES = "search/setPriceTypes";

// localStorage store
// mutations
export const TOGGLE_REMEMBER_ME = "toggleRememberMe";
export const SET_ID_FOR_REMEMBER = "setIdForRemember";
// mutations with location
export const LOCALSTRAGE__TOGGLE_REMEMBER_ME = "localStorage/toggleRememberMe";
export const LOCALSTRAGE__SET_ID_FOR_REMEMBER = "localStorage/setIdForRemember";

export const baiduUrl = [
  {
    1: "https://hm.baidu.com/hm.js?6cfce856cf3f5df784b0b1aadf21bd3d",
    2: "https://hm.baidu.com/hm.js?3239c064478304e990de3ef1a4868617",
    3: "https://hm.baidu.com/hm.js?8ad35043ae693c8a8bab14699374bbe3",
  },
  {
    1: "https://hm.baidu.com/hm.js?7edb4d4233df2219b6694a58c0ac9879",
    2: "https://hm.baidu.com/hm.js?a04050b7e9ca53f1921a7b52d5a1a695",
    3: "https://hm.baidu.com/hm.js?cf8e57c481675212a50cd6a4c0726d2b",
  },
  {
    1: "https://hm.baidu.com/hm.js?e632502a17cfc53900aae2785d41f323",
    2: "https://hm.baidu.com/hm.js?addd641b93c65e697e313b1b892991bc",
    3: "https://hm.baidu.com/hm.js?7c927722cb1f634149c39632c44a35b5",
  },
];

export const COUNT_URL = 4;

export const FUNCTION_OTHER_ID = 110099;

export const expireDateKeyList = [
  "contractYear",
  "contractMonth",
  "contractDay",
];

export const membershipKeyList = [
  "membershipYear",
  "membershipMonth",
  "membershipDay",
];

export const ALL_MANGE_AREA = "ALL";
export const CARD_LIMIT = 24;
export const TABLE_LIMIT = 24;

export const REGEXS = {
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const PLAN_ID = {
  PREMIUM: { value: 30000, emailLimit: 2 },
  STANDARD: { value: 30001, emailLimit: 1 },
  LITE: { value: 30002, emailLimit: 0 },
};

// from /mail/template/q/n
export const MAILING_TYPE = {
  USER_INVITE: 1,
  SUPPLIER_INVITE: 5,
  DEMO_INVITE: 9,
};

export const RESULT_PANEL_TYPE = {
  MARKET: "MARKET",
  BOOK: "BOOK",
  CATEGORY: "CATEGORY",
};

export const ADMIN_MODAL_MODE = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  SELF_EDIT: "SELF_EDIT",
};

export const SHIMA_USER_MODAL_MODE = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  SELF_EDIT: "SELF_EDIT",
};
export const INVITE_MODAL_MODE = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  SELF_EDIT: "SELF_EDIT",
};

export const HELP_KIND_TYPE = {
  FAQ: 31001,
  GUIDE: 31002,
  TRAINING: 31003,
};

export const THEME = {
  BEIGE: "BEIGE",
  BLUE: "BLUE",
};

export const ADD_INFO_BY_LANGUAGE_TYPE = {
  BOOK_NAME: "BOOK_NAME",
  EXTERNAL_LINK: "EXTERNAL_LINK",
};

export const MANGE_MEMBERS_MODE = {
  VIEW: "VIEW",
  ADD: "ADD",
  DONE: "DONE",
  ALTER_MANAGER: "ALTER_MANAGER",
};

export const PROFILE_MANAGER_MODE = {
  VIEW: "VIEW",
  EDIT: "EDIT",
};

export const ACCOUNT_FORM_TARGET = {
  CREATE_INPUT_MANGER_CONFIRM: "CREATE_INPUT_MANGER_CONFIRM", // manager confirm 3
  CREATE_INPUT_MANGER: "CREATE_INPUT_MANGER", // manger account create 2
  CREATE_COMPANY: "CREATE_COMPANY", // manager company create 1
  CREATE_INPUT_STAFF: "CREATE_INPUT_STAFF", // staff create 11
  CREATE_SUCCESS: "CREATE_SUCCESS", // create success 33
  CREATE_INPUT: "CREATE_INPUT", // guest create 11
  CREATE_VIEW: "CREATE_VIEW", // guest view 22
  UPDATE: "UPDATE",
  ADMIN_CREATE: "ADMIN_CREATE", // 111
  ADMIN_CREATE_CONFIRM: "ADMIN_CREATE_CONFIRM", // 222
  ADMIN_UPDATE: "ADMIN_UPDATE",
};

export const INVITE_STATUS = {
  CONFIRM_EMAIL: "CONFIRM_EMAIL",
  REGISTER_INFORMATION: "REGISTER_INFORMATION",
  CONFIRM_INFORMATION: "CONFIRM_INFORMATION",
};

// same as company status
export const USER_STATUS = {
  ACTIVE: 17001,
  INACTIVE: 17002,
  LOCKED: 17003,
  WITHDRAWAL: 17004,
  DELETED: 17009,
};

export const USER_SS_TYPE = {
  GUEST: "Guest",
  KNIT: "Knit",
  SYSTEM: "System",
};

export const LOGIN_MODE = {
  NORMAL: "NORMAL",
  CODE: "CODE",
};

export const FORM_INPUT_MODE = {
  EDIT: "EDIT",
  VIEW: "VIEW",
  SUCCESS: "SUCCESS",
};

export const searchMapper = {
  selectedSeason: "season",
  selectedProperGauge: "properGauge",
  selectedEnds: "ends",
  selectedType: "typeYarn",
  selectedPrice: "priceZone",
  materialLog: "materialLog",
  selectedMaterial: "material",
  selectedOptionMaterial: "optionMaterial",
  selectedOptionWool: "optionWool",
  selectedSubSilk: "subSilk",
  selectedSubCotton: "subCotton",
  selectedSubPolyester: "subPolyester",
  selectedDetailOptionMaterial: "detailOptionMaterial",
  selectedColor: "colorType",
  materialOnly: "materialOnly",
  selectedCharacteristics: "characteristic",
  selectedFunctions: "function",
  selectedCertifications: "ecomark",
  selectedCompany: "company",
  status: "yarnStatus",
  selectedRecommend: "recommended",
  selectedValidEco: "validEco",
};

export const YARN_CARD_FOOTER_TYPES = [
  "COMPANY",
  "REPORT",
  "SUPPLIER",
  "YARN_STATUS",
  "YARN_COLOR",
];

export const yarnCardFooterType = {
  YARN_COMPANY: YARN_CARD_FOOTER_TYPES[0],
  YARN_REPORT: YARN_CARD_FOOTER_TYPES[1],
  SUPPLIER: YARN_CARD_FOOTER_TYPES[2],
  YARN_STATUS: YARN_CARD_FOOTER_TYPES[3],
  YARN_COLOR: YARN_CARD_FOOTER_TYPES[4],
};

export const BLANK_OPTION = {
  text: "",
  value: null,
};

export const CANCEL_REQUEST_MESSAGE = "CANCEL_REQUEST";

export const COMPANY_MAIL_STATUS = {
  DRAFT: 1,
  CONFIRM: 2,
  ACCEPTED: 3,
  DENIED: 4,
  SENT: 5,
};

export const COMPANY_MAIL_STATUS_MAPPER = {
  [COMPANY_MAIL_STATUS.DRAFT]: "newsletter.10843",
  [COMPANY_MAIL_STATUS.CONFIRM]: "newsletter.10844",
  [COMPANY_MAIL_STATUS.ACCEPTED]: "newsletter.10845",
  [COMPANY_MAIL_STATUS.DENIED]: "newsletter.10846",
  [COMPANY_MAIL_STATUS.SENT]: "newsletter.10847",
};

export const STOCK_OPTIONS = {
  INQUIRY: 113000,
  NO_STOCK: 113001,
  STOCK_AVAILABLE: 113002,
};

export const SERVER_ENV = {
  STAGING: "staging",
  TRIAL: "trial",
  SS_STAGING: "ss-staging",
  SS_PRODUCTION: "ss-production",
};

export const LANGUAGE_MESSAGES = {
  en: {
    requiredNote: 'Please fill in the white fields. *Required items',
    title: 'Title of newsletter',
    insertImage: 'Inserted Image',
    insertImageNote:
      'Please attach the file to your email when you reply. (Approximate image size: 800 x 500 pixels).',
    imageLink: 'Link of the image.',
    imageLinkNote:
      'Enter the URL of the page that users will jump to when they click the image above.',
    header: 'Header',
    bodyText: 'Body text',
    link: 'Link',
    nameOfLink: 'Name',
    urlOfLink: 'URL',
    urlOfLinkNote: 'If entering, please enter values in both fields.',
    companyName: 'Company name',
    hpAddress: 'HP Address',
    hpAddressNote:
      'If the URL is different for each language, please fill in the form for each language.',
    mailInquiry: 'Mail address for inquiry',
    mailInquiryNote: 'Please note that your email address will be disclosed.',
    message: {
      save: 'Your draft was saved and added to the list',
      confirm: 'Your e-mail will be delivered on the date you wish it to be delivered after it has been reviewed by SHIMA SEIKI. Please wait for confirmation by SHIMA SEIKI.',
      delete: 'Do you want to delete the mail history?',
      internalConfirm: 'The confirmation email has been sent.',
      sizeResolution: 'Only images with a resolution of 800x500 or more can be specified.',
      sizeLimit: 'Image too large, please upload less than 10MB.'
    },
    languageOptions: 'Language (* Number of users who selected the corresponding language* )'
  },
  ja: {
    requiredNote: '白枠内に入力してください ※必須項目',
    title: 'メールタイトル',
    insertImage: '差し込み画像',
    insertImageNote:
      'このエクセルを返信いただく際に添付してください。画像サイズ目安: 縦横 800 x 500 pixel 程度',
    imageLink: '画像リンク',
    imageLinkNote:
      '上記画像をユーザーがクリックした時に遷移するページのURLを入力してください。',
    header: '見出し',
    bodyText: '本文',
    link: 'リンク',
    nameOfLink: '名',
    urlOfLink: 'URL',
    urlOfLinkNote: 'If entering, please enter values in both fields.',
    companyName: '会社名',
    hpAddress: 'HP Address',
    hpAddressNote:
      '言語ごとにURLが異なる場合、各言語のフォームに入力してください',
    mailInquiry: '問い合わせアドレス',
    mailInquiryNote: 'お問い合わせはこちら」部分に設定されます。 公開されても差し支えないメールアドレスをご入力ください。',
    message: {
      backUnSaved: '保存されていませんが、このまま戻りますか？',
      confirmLimit: 'メルマガの送信可能数が0のため、処理を終了します。',
    },
    comment: {
      title: 'コメントがあれば入力し、確認依頼ボタンを押してください。',
      requestConfirmation: '確認依頼 ',
      back: '戻る',
      withdrawal: ' 取り下げ'
    },
    accepted: {
      title: '指定された送信先にメルマガを送信します。送信先は以下です。よろしければOKボタンを押下してください。',
      selectedLanguage: '選択された言語',
      selectedIndustry: '選択されたビジネスカテゴリー',
      selectedCountry: '選択された国 ',
      japanese: '日',
      english: '英',
      chinese: '中',
    },
    languageOptions: '言語(*該当言語選択ユーザー数*)'
  },
  zh: {
    requiredNote: 'Please fill in the white fields. *Required items',
    title: 'Title of newsletter',
    insertImage: 'Inserted Image',
    insertImageNote:
      'Please attach the file to your email when you reply. (Approximate image size: 800 x 500 pixels).',
    imageLink: 'Link of the image.',
    imageLinkNote:
      'Enter the URL of the page that users will jump to when they click the image above.',
    header: 'Header',
    bodyText: 'Body text',
    link: 'Link',
    nameOfLink: 'Name',
    urlOfLink: 'URL',
    urlOfLinkNote: 'If entering, please enter values in both fields.',
    companyName: 'Company name',
    hpAddress: 'HP Address',
    hpAddressNote:
      'If the URL is different for each language, please fill in the form for each language.',
    mailInquiry: 'Mail address for inquiry',
    mailInquiryNote: 'Please note that your email address will be disclosed.',
    message: {
      save: 'Your draft was saved and added to the list',
      confirm: 'Your e-mail will be delivered on the date you wish it to be delivered after it has been reviewed by SHIMA SEIKI. Please wait for confirmation by SHIMA SEIKI.',
      delete: 'Do you want to delete the mail history?',
      internalConfirm: 'The confirmation email has been sent.',
      sizeResolution: 'Only images with a resolution of 800x500 or more can be specified.',
      sizeLimit: 'Image too large, please upload less than 10MB.'
    },
    languageOptions: 'Language (* Number of users who selected the corresponding language* )'
  }
}

export const LANGUAGE = {
  ENGLISH: { value: 'en', tab: 0 },
  JAPANESE: { value: 'ja', tab: 1 },
  CHINESE: { value: 'zh', tab: 2 },
  ITALIAN: { value: 'it', tab: 3 }
}

// dummy class for checking type
export class WaitingServer {}

export let BAIDU = {
  src: '',
}

export const YARN_FORM_TYPE = {
  ADMIN_CREATE: 'ADMIN_CREATE',
  ADMIN_UPDATE: 'ADMIN_UPDATE',
  CUSTOMER_UPDATE: 'CUSTOMER_UPDATE',
  CUSTOMER_CREATE: 'CUSTOMER_CREATE'
}

export const YARN_COMPNAY_INFO_OPTIONS = {
  in: {
    horizontal: {
      divisions: [
        {
          pixelGap: 0.1,
          lineLength: 0.05
        },
        {
          pixelGap: 0.5,
          lineLength: 0.1
        },
        {
          pixelGap: 1,
          lineLength: 0.15
        }
      ],
      textDefaults: {
        offset: 0.23,
        className: 'green horizontal'
      }
    },
    vertical: {
      divisions: [
        {
          pixelGap: 0.1,
          lineLength: 0.05
        },
        {
          pixelGap: 0.5,
          lineLength: 0.1
        },
        {
          pixelGap: 1,
          lineLength: 0.15
        }
      ],
      textDefaults: {
        offset: 0.23,
        className: 'green vertical',
        rotation: -90
      }
    }
  },
  cm: {
    horizontal: {
      divisions: [
        {
          pixelGap: 0.1,
          lineLength: 0.2
        },
        {
          pixelGap: 0.3,
          lineLength: 0.3
        },
        {
          pixelGap: 1,
          lineLength: 0.4
        }
      ],
      textDefaults: {
        offset: 0.6,
        className: 'blue horizontal'
      }
    },
    vertical: {
      divisions: [
        {
          pixelGap: 0.1,
          lineLength: 0.2
        },
        {
          pixelGap: 0.3,
          lineLength: 0.3
        },
        {
          pixelGap: 1,
          lineLength: 0.4
        }
      ],
      textDefaults: {
        offset: 0.6,
        className: 'blue vertical',
        rotation: -90,
        centerText: {
          by: 'height',
          operation: 'sum' // 'sum' or 'sub'
        }
      }
    }
  }
}

export const FABRIC_UNIT_LIST = [
  { value: 'cm', text: 'cm' },
  { value: 'in', text: 'inch' }
]

export const CONTINENT_LANG = {
  ES: 10726,
  OC: 10727,
  AF: 10728,
  SS: 10735,
  EU: 10729,
  NA: 10730,
  SA: 10731,
  WS: 10732,
  CS: 10733,
  AN: 10734
}

export const ADMIN_PROFILE_TYPE = {
  VIEW: 'VIEW',
  EDIT: 'EDIT'
}

export const limitOptions = [20, 50, 100]

export const COMPANY_FORM_TYPE = {
  ADMIN_CREATE: 'ADMIN_CREATE',
  ADMIN_CREATE_CONFIRM: 'ADMIN_CREATE_CONFIRM',
  ADMIN_UPDATE: 'ADMIN_UPDATE',
  CUSTOMER_UPDATE: 'CUSTOMER_UPDATE',
  CUSTOMER_VIEW: 'CUSTOMER_VIEW',
  MANAGER_CREATE: 'MANAGER_CREATE',
  MANAGER_CONFIRM: 'MANAGER_CONFIRM'
}

export const primaryMinorColorMapper = {
  BLUE: "#004f99",
}

export const INVITE_MAIL_MODAL_MODE = {
  USER: 'USER',
  SUPPLIER: 'SUPPLIER',
  SHIMA: 'SHIMA'
}

export const USER_OPTIONS = [
  {
    "mcdId": 15,
    "codeId": "Knit",
    "apexId": 0,
    "seq": 0,
    "imgPath": null,
    "reservedInt": null,
    "reserved255": null,
    "reserved512": null,
    "relationShip": null,
    "locale": "en",
    "codeName": "Knit User",
    "codeDescription": null
  },
  {
    "mcdId": 15,
    "codeId": "System",
    "apexId": 0,
    "seq": 10,
    "imgPath": null,
    "reservedInt": null,
    "reserved255": null,
    "reserved512": null,
    "relationShip": null,
    "locale": "en",
    "codeName": "System User",
    "codeDescription": null
  },
  {
    "mcdId": 15,
    "codeId": "Guest",
    "apexId": 0,
    "seq": 30,
    "imgPath": null,
    "reservedInt": null,
    "reserved255": null,
    "reserved512": null,
    "relationShip": null,
    "locale": "en",
    "codeName": "Guest User",
    "codeDescription": null
  }
]

export const BLOCK_DOWNLOAD_MODAL = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
}